<template>
  <div class="Container">
    <h2 class="ViewHeading">Device List</h2>
    <div v-if="profileportal === 'CEU'">
      <DeviceCEU />
    </div>
   
    
  </div>
</template>

<script>
import DeviceCEU from "@/components/DeviceListCEU"; // @ is an alias to /src



export default {
  name: "AdminOuter",
  components: {
    DeviceCEU,
   
  
  },
  created() {
    this.$auth.renewTokens().catch((err) => {
      (err.message);
    });
  },
  data() {
    return {
      profileportal: null,
      Auth0loggedIn: false,
      profile: {},
      themepref: this.$ThemePref,
      accessGroup: null,
    };
  },
  methods: {
    handleLoginEvent(data) {
      this.profile = data.profile;
      this.Auth0loggedIn = data.Auth0loggedIn;
      this.profileportal = data.profileportal;
      this.themepref = data.themepref;
      this.accessGroup = data.accessGroup;
    },
  },
};
</script>

<style></style>
